import { Component, OnInit } from '@angular/core';
import { BaseDynamicViewComponent } from 'src/app/common/components/dynamic-view-v2/components/base-dynamic-form/base-dynamic-view.component';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import { DynamicViewType } from 'src/app/common/components/dynamic-view-v2/enums/DynamicViewType';
import BaseEntityDto from 'src/app/common/dtos/BaseEntityDto';
import { BaseViewFieldType } from 'src/app/common/components/dynamic-view-v2/enums/BaseViewFieldType';

@Component({
  selector: 'app-schedule-type-view-v2',
  templateUrl: './schedule-type-view-v2.component.html',
  styleUrls: ['./schedule-type-view-v2.component.sass']
})
export class ScheduleTypeViewV2Component extends BaseDynamicViewComponent implements OnInit
{
  scheduleTypeRecord: BaseEntityDto = new BaseEntityDto();
  constructor()
  {
    super();
  }

  /**
   * Schedule Type View V2 Initial Implementation
   */
  ngOnInit()
  {
    this.fields =
    [
      {
        title: "Schedule Type Data",
        fields:
        [
          { name: "Description", inputType: DynamicViewType.BaseViewField, viewTypes: [BaseViewFieldType.Text], clearField: true, key: 'description', label: 'Description' },
          { name: "Color", inputType: DynamicViewType.BaseViewField, viewTypes: [BaseViewFieldType.ColorDisplay], clearField: true, key: 'color', label: 'Color' }
        ],
        type: DynamicCardType.Card
      }
    ]
    // This will help us to define fields
    // with pre-established values.
    // This is just an example, there is no
    // need to add it if it's not necessary.
    this.scheduleTypeRecord =
    {
      enabled: false
    };
    this.title = "Schedule Type";
    this.viewRoute = 'schedule-types';
    this.isLoading = false;
  }

  /**
   * Validate Schedule Type required field.
   *
   * @param scheduleType Schedule Type record
   */
  validateScheduleType(scheduleType: any)
  {
    return scheduleType && scheduleType.name && scheduleType.name.length > 0;
  }
}
